import React from 'react'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import {
  SearchBar,
  getSorting,
  SORTING_DRAFT,
  SORTING_NEW,
  SORTING_OLD,
  SORTING_PUBLISHED,
  TranslationDictionary,
  useLocale
} from '@plandi/common'
import clsx from 'clsx'

import { useProjectMeFiltersStyles } from './project-me-filters.styles'
import { useQueryProjectCategories } from '../project-queries'
import { useProjectsMeFilters } from '../use-projects-me-filters'

type ProjectMeFiltersProps = {
  translate?: TranslationDictionary['data']
}

export const ProjectMeFilters: React.FC<ProjectMeFiltersProps> = ({
  translate
}) => {
  const locale = useLocale()
  const classes = useProjectMeFiltersStyles()
  const { categoryId, sort, clearProjectMeFilters, setProjectsMeFilters } =
    useProjectsMeFilters()

  const { data: categories } = useQueryProjectCategories()

  const renderCategories = () => {
    return (
      <div style={{ position: 'relative' }}>
        <TextField
          select
          value={categoryId ?? ''}
          className={classes.select}
          onChange={(event) =>
            setProjectsMeFilters({
              categoryId: event.target.value
                ? Number(event.target.value)
                : undefined
            })
          }
        >
          {categories?.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </TextField>
        {!categoryId && (
          <span className={classes.defaultText}>
            {locale === 'ru' ? 'Проекты' : 'Projects'}
          </span>
        )}
      </div>
    )
  }

  const renderSort = () => {
    return (
      <TextField
        select
        value={sort || 'new'}
        defaultValue={translate?.default}
        className={clsx(classes.select, classes.sort)}
        onChange={(event) =>
          setProjectsMeFilters({ sort: event.target.value as typeof sort })
        }
      >
        {[SORTING_NEW, SORTING_OLD, SORTING_PUBLISHED, SORTING_DRAFT].map(
          (key) => (
            <MenuItem key={key} value={key}>
              {getSorting(translate)[key]}
            </MenuItem>
          )
        )}
      </TextField>
    )
  }

  return (
    <>
      <div className={classes.filterContainer}>
        <SearchBar
          className={classes.searchBar}
          invisibleBadge={Boolean(categoryId)}
          searchType="projects"
        >
          {renderCategories()}
          {renderSort()}
          <Button
            fullWidth
            className={classes.clearButton}
            onClick={clearProjectMeFilters}
          >
            {translate?.['throw-off']}
          </Button>
        </SearchBar>
        <div className={classes.selectContainer}>
          {renderCategories()}
          <Button
            className={classes.clearButton}
            onClick={clearProjectMeFilters}
          >
            {translate?.['throw-off']}
          </Button>
          {renderSort()}
        </div>
      </div>
    </>
  )
}
